module.exports = __webpack_public_path__ + "static/media/bowl-veggies1440.427d05e9.jpeg";